import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";
import { getHumanReadableNameCellHelper } from "../../../../../../../utils";
import { ValueLanguage } from "../../../../../../../assets/languages/langs";

import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model,
	language?: ValueLanguage,
): string => {
	const points = getOrderPassengerPoints(item) ?? [];
	return getHumanReadableNameCellHelper(points?.[0]?.sector?.name, language);
};

export default cellProcessing;
